import React, { useEffect, useState } from "react";
import appIcon from "../../assets/IndeeFlix-logo-only.png";
import playStoreIcon from "../../assets/GetItOnGooglePlay_English.png";  // Add in assets
import appStoreIcon from "../../assets/app-store.png";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const InstallPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();

  useEffect(() => {
    const alreadyShown = localStorage.getItem("installPopupShown");
    const isMobile = window.innerWidth <= 768;

    if (!alreadyShown && isMobile) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        localStorage.setItem("installPopupShown", "true");
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => setShowPopup(false);

  const handleInstallAndroid = () => {
    const packageName = "com.ind.indeeclips";
    window.location.href = `intent://details?id=${packageName}#Intent;scheme=market;package=com.android.vending;end;`;
  };

  const handleInstallIOS = () => {
    window.location.href = "https://apps.apple.com/in/app/indeeclips/id6748682495";
  };

  const handleInstall = () => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      handleInstallAndroid();
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !(typeof window !== "undefined" && "MSStream" in window)) {
      handleInstallIOS();
    } else {
      window.location.href = "https://indeeclips.com";
    }
  };

  if (!showPopup) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "14px",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        zIndex: 9999,
        boxShadow: theme.shadows[6],
        width: "92%",
        maxWidth: "420px",
      }}
    >
      {/* Top Section: App icon + name */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <img
          src={appIcon}
          alt="IndeeClips"
          style={{ width: "40px", height: "40px", borderRadius: "8px" }}
        />
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ fontWeight: "600", fontSize: "16px" }}>
            {t("installPopup.title")}
          </span>
          <span style={{ fontSize: "13px", color: theme.palette.text.secondary }}>
            {t("installPopup.subtitle")}
          </span>
        </div>
      </div>

      {/* Install button */}
      <button
        onClick={handleInstall}
        style={{
          marginTop: "14px",
          background: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          border: "none",
          borderRadius: "8px",
          padding: "10px 18px",
          cursor: "pointer",
          fontSize: "15px",
          fontWeight: "600",
          width: "100%",
        }}
      >
        {t("installPopup.installButton")}
      </button>

      {/* Store icons */}
      <div
        style={{
          display: "flex",
          gap: "14px",
          marginTop: "12px",
          alignItems: "center",
        }}
      >
        <img
          src={playStoreIcon}
          alt={t("installPopup.store.googlePlay")}
          style={{ width: "120px", height: "auto", cursor: "pointer" }}
          onClick={handleInstallAndroid}
        />
        <img
          src={appStoreIcon}
          alt={t("installPopup.store.appStore")}
          style={{ width: "120px", height: "auto", cursor: "pointer" }}
          onClick={handleInstallIOS}
        />
      </div>

      {/* Close button */}
      <button
        onClick={handleClose}
        style={{
          position: "absolute",
          top: "8px",
          right: "10px",
          background: "transparent",
          border: "none",
          fontSize: "20px",
          color: theme.palette.text.secondary,
          cursor: "pointer",
          lineHeight: "1",
        }}
      >
        ✕
      </button>
    </div>
  );
};

export default InstallPopup;
